var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.6663H4.66667C3.93029 14.6663 3.33333 14.0694 3.33333 13.333V4.66634H2V3.33301H4.66667V2.66634C4.66667 1.92996 5.26362 1.33301 6 1.33301H10C10.7364 1.33301 11.3333 1.92996 11.3333 2.66634V3.33301H14V4.66634H12.6667V13.333C12.6667 14.0694 12.0697 14.6663 11.3333 14.6663ZM4.66667 4.66634V13.333H11.3333V4.66634H4.66667ZM6 2.66634V3.33301H10V2.66634H6ZM10 11.9997H8.66667V5.99967H10V11.9997ZM7.33333 11.9997H6V5.99967H7.33333V11.9997Z",
    fill: "#093F8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashfull);
export default __webpack_public_path__ + "static/media/trashfull.a9134464.svg";
export { ForwardRef as ReactComponent };